<template>
  <v-form ref="form" @submit="Register" lazy-validation>
    <v-card class="elevation-12">
      <v-card-title primary-title class="primary">
        <div class="headline white--text">Register</div>
      </v-card-title>
      <v-card-text>
        <v-text-field
          autocomplete="username"
          prepend-icon="person"
          name="username"
          label="Username"
          :rules="nameRules"
          :disabled="loading"
          v-model="user.username"
          type="text">
        </v-text-field>
        <v-text-field
          autocomplete="email"
          prepend-icon="mail"
          name="email"
          label="Email"
          :rules="emailRules"
          :disabled="loading"
          v-model="user.email"
          type="text">
        </v-text-field>
        <v-text-field
          autocomplete="new-password"
          id="password"
          prepend-icon="lock"
          name="password"
          label="Password"
          :rules="passwordRules"
          :disabled="loading"
          v-model="user.password"
          type="password">
        </v-text-field>
        <router-link :to="{ name: 'SignIn' }">Login</router-link>&nbsp;
        <router-link :to="{ name: 'ForgotPassword' }">Forgot password?</router-link>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          @click="Register"
          :loading="loading"
          type="submit">
          Register
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'SignUp',
  data() {
    return {
      loading: false,
      nameRules: [
        v => !!v || 'Username ist ein Pflichtfeld',
        v => (v && v.length <= 10) || 'Username must be less than 10 characters',
      ],
      emailRules: [
        v => !!v || 'E-mail ist ein Pflichtfeld',
        // eslint-disable-next-line
        v => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail must be valid',
      ],
      passwordRules: [
        v => !!v || 'Passwort ist ein Pflichtfeld',
      ],
      user: {
        username: null,
        email: null,
        password: null,
      },
    };
  },
  methods: {
    ...mapActions({
      signUp: 'auth/signUp',
      showSnackbar: 'snackbar/success',
    }),
    Register(e) {
      e.preventDefault();
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.signUp(this.user)
          .then((res) => {
            console.log(res);
            this.loading = false;

            this.showSnackbar('User created, check your email for the activation code.');
            this.$router.push({ name: 'ConfirmSignUp' });
          });
      }
    },
  },
};
</script>

<style scoped>

</style>
